import { createFileRoute } from '@tanstack/react-router'
import HouseDetailsPage from '@/features/houses/components/house-details/house-details-page'

export const Route = createFileRoute(
  '/_authenticated/dashboard/houses/$houseId/',
)({
  component: HouseDetailsPage,
})
